/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import ObjectValue, { type FieldObjectType } from './ObjectValue';
import { Rect } from '@lib/canvasx/components/Rect';
import {
  type ButtonState,
  ButtonStyles,
  formattedRgba,
} from '../canvasx/buttonStyles';
import { isShape } from './guards';
import { SquareIcon } from '../canvasx/SquareIcon';
import { OPEN_RECORD } from './IconsHelper';
import type WhiteboardController from '../controllers/WhiteboardController';

class OpenIntegrationLinkAction extends ObjectValue {
  static shouldRender(object: FieldObjectType): boolean {
    return isShape(object) && Boolean(object.integrationRecord?.recordData);
  }

  static renderFields(
    maxChildWidth: number,
    object: FieldObjectType,
    controller: WhiteboardController
  ): CanvaSXNode[] {
    if (!isShape(object) || controller.canvas?.exporting || window.isPublishing)
      return [];

    const recordData = object.integrationRecord?.recordData;
    if (!recordData) return [];

    const key = `link:${object.id}`;

    const buttonState: ButtonState =
      object.hoveredKey === key
        ? 'hovered'
        : object.isSelected()
        ? 'selected'
        : 'default';

    const { background, icon } = ButtonStyles[buttonState];

    return [
      <Rect
        key={key}
        padding={3}
        borderRadius={2}
        fill={formattedRgba(background)}
        onClick={() => {
          if (!recordData) {
            return;
          }

          window.open(recordData.url, '_blank', 'noopener,noreferrer');
        }}
        tooltip={`Open ${recordData.recordId}`}
      >
        <SquareIcon
          icon={OPEN_RECORD}
          size={8}
          iconFill={formattedRgba(icon)}
        />
      </Rect>,
    ];
  }
}

export default OpenIntegrationLinkAction;
